import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { NavList, NavListProps } from './NavList';
import {
  selectViewSelectedAgent,
  selectViewSelectedDepartment,
  selectViewTitle,
  selectViewSelectedBrain,
  selectViewSelectedView,
} from '../../redux/selectors';

export type NavListType = 'conversations' | 'teammates' | 'departments' | 'views';

interface NavListContainerProps extends Omit<NavListProps, 'selectedItemId'> {
  type: NavListType;
}

export const NavListContainer = ({ type, ...props }: NavListContainerProps) => {
  const selectedAgent = useSelector(selectViewSelectedAgent);
  const selectedDepartment = useSelector(selectViewSelectedDepartment);
  const viewTitle = useSelector(selectViewTitle);
  const selectedBrain = useSelector(selectViewSelectedBrain);
  const selectedView = useSelector(selectViewSelectedView);

  const selectedItemId = useMemo(() => {
    switch (type) {
      case 'conversations':
        if (viewTitle) {
          const converted = viewTitle === 'me' ? 'inbox' : viewTitle;
          return converted;
        }
        return undefined;

      case 'teammates':
        if (selectedAgent) {
          return selectedAgent;
        }
        if (selectedBrain) {
          return selectedBrain;
        }
        return undefined;

      case 'departments':
        if (selectedDepartment) {
          return selectedDepartment;
        }
        return undefined;

      case 'views':
        if (selectedView) {
          return selectedView;
        }
        return undefined;

      default:
        return undefined;
    }
  }, [selectedAgent, selectedBrain, selectedDepartment, selectedView, viewTitle, type]);

  return <NavList {...props} selectedItemId={selectedItemId} />;
};
